
        import { changeArchs, deleteQrCode, onEnterKey } from "./src/exportUI";
        import { closeConfigDialog, closeExportDialog, exportFaustSource, faustDocumentation, loadFaustCode, openConfigDialog, saveFaustCode, stopFaustCode } from "./src/faustlive";
        import { setBufferSize, setDSPStorage, setPoly, setPolyVoices, setRenderingMode, setSampleFormat, setSourceStorage } from "./src/runfaust";
        Object.assign(window, {
            changeArchs, deleteQrCode, onEnterKey,
            closeConfigDialog, closeExportDialog, exportFaustSource, faustDocumentation, loadFaustCode, openConfigDialog, saveFaustCode, stopFaustCode,
            setBufferSize, setDSPStorage, setPoly, setPolyVoices, setRenderingMode, setSampleFormat, setSourceStorage,
        })
    